module.exports = __webpack_public_path__ + "img/whatsapp.8b47f833.svg";